<template>
  <div id="promotion-locator">
    <!-- Use Same Root Element for Promo Page and Coupons / Specials -->
    <!-- Simplify and use just a single version of the coupon carousel -->
    <!-- If User Has Store -> Display The Following Sections -->
    <section id="store-selection-promotion" v-if="user_store">
      <PromotionBanner
        v-if="promotion.banner !== null"
        :promotion="promotion"
      ></PromotionBanner>
      <div class="container" v-if="storePromotions.length > 0">
        <div class="row mt-4">
          <div class="col-md-12">
            <h2 class="text-center text-uppercase">
              Come to
              <strong
                >Tint World<sup>&reg;</sup> {{ user_store.address.city }},
                {{ user_store.address.region }}</strong
              >
              For All <span class="nowrap">Your Vehicle Upgrades!</span>
            </h2>
            <p class="text-center">
              Get To Your Tint World Before These Deals Run Out!
            </p>
          </div>
        </div>
      </div>
      <div class="container" v-else>
        <div class="row mt-4">
          <div class="col-md-12">
            <h2 class="text-center text-uppercase">
              Come to
              <strong
                >Tint World<sup>&reg;</sup> {{ user_store.address.city }},
                {{ user_store.address.region }}</strong
              >
              For All <span class="nowrap">Your Vehicle Upgrades!</span>
            </h2>
            <p class="text-center mt-4">
              <strong>This Location Does Not Have Any Active Promotions!</strong
              ><br />
              Select a different location or try again later.
            </p>
          </div>
        </div>
      </div>
      <StoreCouponsViewer
        :coupons="storePromotions"
        :promotion="promotion"
        :apiLoading="apiLoading"
      ></StoreCouponsViewer>
      <div class="row store-container-background">
        <div class="container mt-4">
          <div class="row">
            <div class="col-md-12">
              <SingleStoreInfo
                :store="user_store"
                @clearStore="resetStore"
              ></SingleStoreInfo>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- If No User Store -> Show the Promotion Default -->
    <PromoNoUserStore
      :isCouponSpecials="isCouponsSpecials"
      :promotion="promotion"
      v-else
    ></PromoNoUserStore>
  </div>
</template>
<!-- @TODO - May need to split functionality here as PPC doesn't technically support Vue Bootstrap -->
<script>
import SingleStoreInfo from "@/components/partials/SingleStoreInfo.vue";
import StoreCouponsViewer from "@/components/promotion/StoreCouponsViewer";
import PromoNoUserStore from "@/components/promotion/PromoNoUserStore";
import PromotionBanner from "@/components/promotion/PromotionBanner";
export default {
  name: "PromoPage",
  //@TODO - We should also check logic for situations where MyStore is set but no promotion is assigned (though we can probably capture that via server and populate default coupons?)
  components: {
    SingleStoreInfo,
    StoreCouponsViewer,
    PromoNoUserStore,
    PromotionBanner,
  },
  data: () => {
    return {
      currentSlide: 0,
      apiLoading: true,
      promotionTitle: "",
      excerpt: "",
      promotionId: 0,
    };
  },
  props: {
    formType: String,
  },
  created() {
    const vm = this;
    // Get Promotion ID
    if (window.$promotionId !== undefined) {
      this.promotionId = window.$promotionId;
    }
    if (this.user_store) {
      this.$store
        .dispatch("loadCurrentPageStorePromotion", {
          storeId: this.user_store["location-id"],
          promotionId: vm.promotionId,
        })
        .then(function () {
          vm.apiLoading = false;
        })
        .catch(function () {
          vm.apiLoading = false;
        });
      //@TODO - Add a then->trigger data update to handle transition
      vm.apiLoading = false;
    } else {
      this.fetchPromotion();
    }
  },
  mounted: function () {},
  watch: {
    user_store: function (newStore, oldStore) {
      if (
        newStore !== null &&
        newStore["location-id"] !== oldStore["location-id"]
      ) {
        this.fetchCoupons();
      }
    },
  },
  computed: {
    isCouponsSpecials() {
      if (this.promotionId == 0) {
        return true;
      }
      return false;
    },
    carouselView() {
      if (this.storePromotions.length == 0) {
        return false;
      }
      if (this.storePromotions.length >= 4) {
        return true;
      }
      if (this.storePromotions.length < 4) {
        return false;
      }
      return false;
    },
    hasCoupons() {
      if (this.storePromotions.length > 0) {
        return true;
      }
      return false;
    },
    storePromotions() {
      return this.$store.state.page_promotion.store_coupons;
    },
    promotion() {
      return this.$store.state.page_promotion;
    },
    selectedCoupon() {
      return this.currentSlide;
    },
    userHasStore() {
      return this.$store.getters.userHasStore;
    },
    userStore() {
      return this.$store.getters.formStore;
    },
    checkCoupons() {
      //@TODO - we'll need to add a cache timing or indicator to refresh these at certain intervals
      //@TODO - Need to also allow for 'checking' if/when the promo has changed when going directly to promo pages
      if (this.user_store) {
        if (this.page_promotion.store_coupons.length > 1) {
          if (
            this.page_promotion.store_id ==
            parseInt(this.user_store["location-id"])
          ) {
            return true;
          }
        }
      }
      return false;
    },
    user_store() {
      if (this.userHasStore && this.$store.state.myStore !== null) {
        return this.$store.state.myStore;
      }
      return false;
    },
  },
  methods: {
    triggerModal(index) {
      this.currentSlide = parseInt(index);
      //this.$bvModal.show('store-promo-modal');
      this.$root.$bvModal.show("store-promo-modal");
      //this.$bvModal.preventDefault();
    },
    resetStore() {
      this.$store.commit("setStore", null);
    },
    setStore() {
      this.fetchCoupons();
    },
    fetchPromotion() {
      this.$store.dispatch("loadPagePromotion", this.promotionId);
    },
    fetchCoupons() {
      //@TODO - We need to add functionality to pivot / query the specific promotion this page is asking for vs. allowing the 'active' as it will pull the wrong promo depending on the page
      //@TODO - Need to add map/assoc to pull from the store-promo page
      const vm = this;
      vm.apiLoading = true;
      this.$store
        .dispatch("loadCurrentPageStorePromotion", {
          storeId: this.user_store["location-id"],
          promotionId: this.promotionId,
        })
        .then(function () {
          //@TODO - Determine if this resolved or failed
          vm.apiLoading = false;
          //@TODO - Need to account for potential error scenarios here
        });
    },
    triggerQuote() {
      window.tintworldVue.$root.$store.commit("OpenModal", "quote");
      window.tintworldVue.$root.$emit("bv::show::modal", "tint-world-modal");
      //window.tintworldVue.$root.$emit('bv::show::modal','quote-modal');
      //this.$root.$emit('bv::show::modal','quote-modal');
    },
    triggerAppointment() {
      window.tintworldVue.$root.$store.commit("OpenModal", "appointment");
      window.tintworldVue.$root.$emit("bv::show::modal", "tint-world-modal");
      //window.tintworldVue.$root.$emit('bv::show::modal','appointment-modal');
      //this.$root.$emit('bv::show::modal','appointment-modal');
    },
  },
};
</script>

<style scoped>
@media (min-width: 768px) {
  .nowrap {
    white-space: nowrap;
  }
}
.coupon-image:hover {
  cursor: pointer;
}
.menu-padder {
  margin-top: 50px;
}
#store-info-container .map-area {
  order: 2;
}
#store-info-container .place-detail-area {
  order: 1;
}
.store-container-background {
  background: #f3f3f3;
}
.default-coupons-header {
  padding-bottom: 28%;
  position: relative;
}
.default-banner-container {
  background-image: url(https://res.cloudinary.com/tint-world/image/upload/w_auto,f_auto,q_auto:good/tw-uploads-2/images/img-coupons-specials/hero_b7f326e5.jpg);
  color: #fff;
  height: 100%;
  width: 100%;
  background-size: cover;
  position: absolute;
}
</style>
